import React from 'react';
import styles from './PermitsPage.module.scss';
import Permits from '../../modules/permits';

const PermitsPage = () => {
  return (
    <div className={styles.root}>
      <Permits />
    </div>
  );
};

export default PermitsPage;
